import { apiClient } from '@/shared/api';

import { Contacts } from '../config';

export async function contactApi(): Promise<Contacts> {
  return await apiClient(`contact`);
}
